import React from 'react';
import { X, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * ParametersModal - Modal for displaying input parameters used in agent reports.
 * Shows parameters in a clean grid layout when the info icon is clicked.
 */
export const ParametersModal = ({ isOpen, onClose, parameters }) => {
    const { t } = useTranslation(['ui-complex', 'common']);
    if (!isOpen || !parameters || Object.keys(parameters).length === 0) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div 
                className="bg-white rounded-xl max-w-2xl w-full shadow-xl"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                            <Target className="w-5 h-5 text-primary-600" />
                        </div>
                        <div>
                            <h3 className="text-xl font-bold text-gray-900">{t('ui-complex:parametersModal.title')}</h3>
                            <p className="text-sm text-gray-500">{t('ui-complex:parametersModal.count', { count: Object.keys(parameters).length })}</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        aria-label={t('ui-complex:parametersModal.closeAriaLabel')}
                    >
                        <X className="w-5 h-5 text-gray-600" />
                    </button>
                </div>

                {/* Parameters Grid */}
                <div className="p-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto">
                        {Object.entries(parameters).map(([key, value]) => (
                            <div key={key} className="bg-primary-50 border border-primary-200 rounded-lg p-4">
                                <p className="text-xs font-medium text-primary-700 mb-1 capitalize">
                                    {key.replace(/_/g, ' ')}
                                </p>
                                <p className="text-lg font-semibold text-gray-900 truncate" title={String(value)}>
                                    {String(value)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
                    >
                        {t('common:close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ParametersModal;
